import './accordion-filter.scss';

class AccordionFilter {
    constructor (element) {
        this.$accordionFilter = element;
        this.$$allAccordionFilters = document.querySelectorAll('[data-accordion-filter-id]');
        this.$filterGroup = this.$accordionFilter.querySelector('[data-accordion-filter="filter-group"]');
        this.$resetButton = this.$accordionFilter.querySelector('[data-accordion-filter="reset"]');

        this.activeClass = 'accordion-filter__filter-item--active';
        this.activeResetClass = 'accordion-filter__reset--active';
        this.hideAccordionClass = 'accordion--hide';
        this.activeAccordionClass = 'accordion--active';
        this.selectedFilters = [];
    }

    initialize () {
        this.buildFilters();
        this.setEvents();
    }

    setEvents () {
        this.$resetButton.addEventListener('click', () => {
            this.resetFilter();
        });
    }

    buildFilters () {
        const newFilters = [];
        this.$$allAccordionFilters.forEach(filter => {
            const filterId = filter.getAttribute('data-accordion-filter-id');
            const filterLabel = filter.getAttribute('data-accordion-filter-label');
            const filterDiv = document.createElement('div');
            filterDiv.textContent = filterLabel;
            filterDiv.dataset.filterTagId = filterId;
            filterDiv.classList.add('accordion-filter__filter-item', 'reverse-icon-plus');
            newFilters.push(filterDiv);
            this.$filterGroup.appendChild(filterDiv);

            filterDiv.addEventListener('click', () => {
                this.toggleFilter(filterId);
            });
        });
    }

    toggleFilter (filterId) {
        const index = this.selectedFilters.indexOf(filterId);
        if (index === -1) {
            this.selectedFilters.push(filterId);
        } else {
            this.selectedFilters.splice(index, 1);
        }

        this.updateFilterDisplay();
    }

    updateFilterDisplay () {
        if (this.selectedFilters.length === 0) {
            this.$$allAccordionFilters.forEach(filter => {
                const filterId = filter.getAttribute('data-accordion-filter-id');
                const filterDiv = this.$filterGroup.querySelector(`[data-filter-tag-id="${filterId}"]`);
                filterDiv.classList.remove(this.activeClass);
                filter.classList.remove(this.hideAccordionClass);
            });

            this.$resetButton.classList.remove(this.activeResetClass);
        } else {
            this.$resetButton.classList.add(this.activeResetClass);
            this.$$allAccordionFilters.forEach(filter => {
                const filterId = filter.getAttribute('data-accordion-filter-id');
                const filterDiv = this.$filterGroup.querySelector(`[data-filter-tag-id="${filterId}"]`);
                if (this.selectedFilters.includes(filterId)) {
                    filterDiv.classList.add(this.activeClass);
                    filter.classList.remove(this.hideAccordionClass);
                } else {
                    filterDiv.classList.remove(this.activeClass);
                    filter.classList.add(this.hideAccordionClass);
                }
            });
        }
    }

    resetFilter () {
        this.selectedFilters = [];
        const $$allFilterTabs = this.$filterGroup.querySelectorAll('.accordion-filter__filter-item');

        this.$$allAccordionFilters.forEach(filter => {
            filter.classList.remove(this.hideAccordionClass);
        });

        $$allFilterTabs.forEach(filterDiv => {
            filterDiv.classList.remove(this.activeClass);
        });

        this.$resetButton.classList.remove(this.activeResetClass);
    }
}

export { AccordionFilter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $accordionFilters = $context.querySelectorAll('[data-accordion-filter="root"]');

    if ($accordionFilters.length > 0) {
        for (let i = 0; i < $accordionFilters.length; i++) {
            const $accordionFilter = new AccordionFilter($accordionFilters[i]);
            $accordionFilter.initialize();
        }
    }
});
